import { useState } from "react";
import { motion } from "framer-motion";
import UdemyCertificate from "../assets/udemycertificate.jpg"
import hackerRankNode from "../assets/nodejscertificate.png"
import sqlCertificate from "../assets/sqlcertificate.png"
import problemSolving from "../assets/problem_solving.png";
import RestApi from "../assets/rest_api_certificate_of_aashish.png"
import PythonAutomation from "../assets/python_automation.png";
import AwsPhoto from "../assets/aws_photo.jpg"
import AwsBadge from "../assets/aws-academy-graduate-aws-academy-cloud-web-applicat.png"
// Certificate data
const certificates = [
  {
    image: UdemyCertificate,
    title: "MERN Stack Certificate",
    description:
      "Creating fully customized web applications from scratch to meet unique requirements.",
    link: "https://www.credly.com/badges/b603191a-cbb7-4e34-967a-08b8a738a14c/public_url",
    issuer: "Aws Academy ",
    date: "2024",
    category: "Full Stack Development",
  },
  {
    image: AwsBadge,
    title: "AWS Academy Graduate",
    description:
      "Deploying and managing web applications on AWS manage scalable and cost-effective cloud solutions.",
    link: "https://www.awsacademy.com/certificate/verify?id=BA-ME12PZUL-RZZ2EV",
    issuer: "AWS Academy",
    date: "2025",
    category: "Cloud Computing",
  },
  {
    image: hackerRankNode,
    title: "Node.js Certificate",
    description:
      "Covers Node.js concepts such as package management, event loop, buffers, streams, and file systems.",
    link: "https://www.hackerrank.com/certificates/081d9eea2337",
    issuer: "HackerRank",
    date: "2023",
    category: "Backend Development",
  },
  {
    image: sqlCertificate,
    title: "SQL Certificate",
    description:
      "Demonstrates ability to work with queries, relationships, joins, and aggregations.",
    link: "https://www.hackerrank.com/certificates/081d9eea2337",
    issuer: "HackerRank",
    date: "2023",
    category: "Database",
  },
  {
    image: problemSolving,
    title: "Problem Solving Certificate",
    description:
      "Validates algorithmic and data structure problem-solving skills.",
    link: "https://www.hackerrank.com/certificates/f9aa9c4a8d09",
    issuer: "HackerRank",
    date: "2022",
    category: "Problem Solving",
  },
  {
    image: RestApi,
    title: "REST API Development Certificate",
    description:
      "Knowledge of RESTful API design, HTTP methods, data formats, and best practices.",
    link: "https://www.hackerrank.com/certificates/7041e7dae843",
    issuer: "HackerRank",
    date: "2023",
    category: "Backend Development",
  },
  {
    image: PythonAutomation,
    title: "Python Automation Certificate",
    description:
      "Automation using Python libraries and tools, including scripting and data handling.",
    link: "https://aashishtimsina.com.np/certificate/python-automation",
    issuer: "HackerRank",
    date: "2023",
    category: "Backend Development",
  },
  {
    image: AwsPhoto,
    title: "AWS Certificate",
    description:
      "Basic knowledge of AWS services, including EC2, S3, and Lambda.",
    link: "https://bingoacademy.thebingolabs.com/verify?id=BA-ME12PZUL-RZZ2EV",
    issuer: "BingoLabs",
    date: "2025",
    category: "Cloud Computing",
  }
];


// Individual Certificate Card Component
const CertificateCard = ({ certificate, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className="w-full"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <motion.div
        className="glass-card relative h-full overflow-hidden rounded-lg border border-primary-500/10 transition-all duration-300"
        whileHover={{
          scale: 1.03,
          boxShadow: "0 0 20px rgba(62, 230, 189, 0.2)",
          borderColor: "rgba(62, 230, 189, 0.3)",
        }}
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
      >
        <div className="relative h-52 overflow-hidden">
          <motion.img
            src={certificate.image}
            alt={certificate.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover object-center"
            initial={{ scale: 1 }}
            animate={{ scale: isHovered ? 1.1 : 1 }}
            transition={{ duration: 0.5 }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent"></div>

          {/* Badge */}
          <div className="absolute top-3 right-3 bg-dark-800/90 glass text-primary-400 text-xs font-medium py-1 px-2 rounded-full border border-primary-500/20">
            {certificate.category}
          </div>
        </div>

        <div className="p-5">
          <div className="flex justify-between items-start mb-3">
            <h3 className="text-lg font-bold text-light-100 mb-2">
              {certificate.title}
            </h3>
          </div>

          <div className="flex items-center mb-3 text-xs space-x-4">
            <div className="text-gray-400">
              <span className="text-primary-400">{certificate.issuer}</span>
            </div>
            <div className="text-gray-400">
              <span>{certificate.date}</span>
            </div>
          </div>

          <p className="text-gray-400 text-sm mb-4">
            {certificate.description}
          </p>

          <a
            href={certificate.link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-sm text-primary-400 hover:text-primary-300 transition-colors"
          >
            <span>View Certificate</span>
            <svg
              className="w-4 h-4 ml-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              ></path>
            </svg>
          </a>
        </div>

        {/* Glow effect on hover */}
        <motion.div
          className="absolute inset-0 pointer-events-none rounded-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: isHovered ? 1 : 0 }}
          transition={{ duration: 0.3 }}
          style={{
            background: `
              radial-gradient(
                500px circle at ${isHovered ? "var(--x)" : "0"} ${
              isHovered ? "var(--y)" : "0"
            },
                rgba(62, 230, 189, 0.06),
                transparent 40%
              )
            `,
          }}
        />
      </motion.div>
    </motion.div>
  );
};

// Certificate Section Component
const Certificates = ({ standalone = false }) => {
  const HeadingTag = standalone ? "h1" : "h2";
  return (
    <section className="py-20 bg-dark-900/40 text-light-100 relative overflow-hidden">
      {/* Background elements */}

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          className="mb-12 max-w-3xl"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="font-code text-sm text-primary-400 mb-3 block">
            Achievements
          </span>
          <HeadingTag className="text-4xl font-bold gradient-text mb-4">
            {standalone
              ? "Certifications | Backend Developer in Nepal"
              : "My Certificates"}
          </HeadingTag>
          <p className="text-lg text-gray-400 max-w-2xl">
            A showcase of my professional certifications and achievements
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {certificates.map((certificate, index) => (
            <CertificateCard
              key={index}
              certificate={certificate}
              index={index}
            />
          ))}
        </div>

        {/* Decorative elements */}
        <div className="mt-16 flex justify-center">
          <motion.div
            className="glass-card border border-primary-500/10 p-6 max-w-2xl text-center rounded-lg"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <h3 className="text-xl font-bold mb-3 gradient-text">
              Continuous Learning
            </h3>
            <p className="text-gray-400">
              I am committed to continuous learning and skill development. These
              certifications represent my dedication to mastering various
              technologies and best practices in web development.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Mouse hover effect script */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
          document.addEventListener('mousemove', (e) => {
            const cards = document.querySelectorAll('.glass-card');
            cards.forEach(card => {
              const rect = card.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
              card.style.setProperty('--x', \`\${x}px\`);
              card.style.setProperty('--y', \`\${y}px\`);
            });
          });
        `,
        }}
      />
    </section>
  );
};

export default Certificates;
